import React, { useState } from "react";
import UploadImage from "../../../partials/image-upload/index.tsx";

const ImageUploadModal = ({ isOpen, onClose }) => {
	console.log("isOpen: " + isOpen);
	if (!isOpen) return null;

	const handleClose = (e) => {
		// e.preventDefault();
		onClose();
	};

	return (
		// <div id="extralarge-modal" tabIndex={-1} className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
		<div
			className="fixed inset-0 flex
                        items-center justify-center
                        bg-black bg-opacity-50">
			<div id="medium-modal" className="fixed items-center justify-center z-50 p-4 inset-0 content-center">
				<div className="relative max-w-lg max-h-full mr-auto ml-auto">
					<div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
						<div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
							<h3 className="text-xl font-medium text-grey-700">Change Profile Picture</h3>
							<button
								onClick={handleClose}
								type="button"
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
								data-modal-hide="extralarge-modal">
								<svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
									<path
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
									/>
								</svg>
								<span className="sr-only">Close modal</span>
							</button>
						</div>
						<div className="modal-body p-6 md:p-6 space-y-4">
							<UploadImage onClose={handleClose} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ImageUploadModal;
